import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

const GRAPHNE_RESOURCES_SOFT_POSSIBLE_TASKS_RESOURCE_ID = 'graphne-resources-soft-possible-tasks-resource-id';

type Params = {
  resourceId: string;
  start?: string;
  end?: string;
};

export const useGraphneResourcesSoftPossibleTasksResourceId = (
  { resourceId, start, end }: Params,
  enabled?: boolean,
) => {
  const api = useGraphneAPI();

  return useQuery({
    queryKey: [GRAPHNE_RESOURCES_SOFT_POSSIBLE_TASKS_RESOURCE_ID, resourceId],
    enabled,
    queryFn: () =>
      api.getGraphneResourcesSoftPossibleTasksResourceid({
        resourceId,
        start,
        end,
      }),
  });
};
